"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const date_fns_1 = require("date-fns");
const react_2 = require("swiper/react");
const swiper_1 = require("swiper");
// Import Swiper styles
require("swiper/css");
require("swiper/css/scrollbar");
function YearlyCalendar({ date, setSelectedDate, locale }) {
    const swiperDate = (0, react_1.useRef)();
    const swiperMonth = (0, react_1.useRef)();
    const swiperYear = (0, react_1.useRef)();
    const initialDate = (0, react_1.useRef)(date);
    const startYearCount = 100;
    const current = (0, date_fns_1.startOfMonth)(date);
    const days = (0, date_fns_1.eachDayOfInterval)({
        start: current,
        end: (0, date_fns_1.endOfMonth)(current),
    });
    const onUpdate = (0, react_1.useCallback)((swiper, type) => {
        switch (type) {
            case "date":
                setSelectedDate((0, date_fns_1.setDate)(date, +swiper.realIndex + 1));
                break;
            case "month":
                setSelectedDate((0, date_fns_1.setMonth)(date, +swiper.realIndex));
                break;
            case "year":
                const year = (0, date_fns_1.getYear)(initialDate.current) - startYearCount + 1;
                setSelectedDate((0, date_fns_1.setYear)(date, year + +swiper.realIndex));
                break;
            default:
                break;
        }
    }, [date, startYearCount, initialDate.current]);
    (0, react_1.useEffect)(() => {
        if (swiperDate.current && swiperMonth.current && swiperYear.current) {
            swiperDate.current.slideTo((0, date_fns_1.getDate)(date) - 1);
            swiperMonth.current.slideTo((0, date_fns_1.getMonth)(date));
            const year = (0, date_fns_1.getYear)(date) - ((0, date_fns_1.getYear)(initialDate.current) - startYearCount);
            swiperYear.current.slideTo(year);
        }
    }, []);
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex justify-between", children: [(0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col px-4 text-center", children: [(0, jsx_runtime_1.jsx)("h6", { className: "text-xs mb-3", children: "Tanggal" }), (0, jsx_runtime_1.jsx)("div", { className: "flex-col flex max-h-24 overflow-auto", children: (0, jsx_runtime_1.jsx)(react_2.Swiper, { modules: [
                                swiper_1.Scrollbar,
                                swiper_1.A11y,
                                swiper_1.Autoplay,
                                swiper_1.EffectCreative,
                                swiper_1.Mousewheel,
                                swiper_1.FreeMode,
                            ], slidesPerView: 3, effect: "slide", direction: "vertical", simulateTouch: true, mousewheel: true, freeMode: {
                                enabled: true,
                                sticky: true,
                            }, speed: 400, centeredSlides: true, onSlideChange: (s) => onUpdate(s, "date"), onSwiper: (s) => {
                                swiperDate.current = s;
                            }, children: days.map((day) => {
                                let dayNumber = (0, date_fns_1.format)(day ?? new Date(), "d", {
                                    locale: locale,
                                });
                                return ((0, jsx_runtime_1.jsx)(react_2.SwiperSlide, { children: ({ isActive }) => ((0, jsx_runtime_1.jsx)("div", { className: [
                                            "flex items-center justify-center font-medium transition-all duration-300 cursor-pointer px-4",
                                            isActive
                                                ? "text-lg text-gray-900 bg-yellow-200"
                                                : " text-gray-500",
                                        ].join(" "), children: dayNumber })) }, dayNumber));
                            }) }) })] }), (0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col px-4 text-center", children: [(0, jsx_runtime_1.jsx)("h6", { className: "text-xs mb-3", children: "Bulan" }), (0, jsx_runtime_1.jsx)("div", { className: "flex-col flex max-h-24 overflow-auto", children: (0, jsx_runtime_1.jsx)(react_2.Swiper, { modules: [
                                swiper_1.Scrollbar,
                                swiper_1.A11y,
                                swiper_1.Autoplay,
                                swiper_1.EffectCreative,
                                swiper_1.Mousewheel,
                                swiper_1.FreeMode,
                            ], slidesPerView: 3, effect: "slide", direction: "vertical", simulateTouch: true, mousewheel: true, freeMode: {
                                enabled: true,
                                sticky: true,
                                momentumRatio: 5,
                                momentumBounceRatio: 5,
                                momentumVelocityRatio: 5,
                                minimumVelocity: 0.5,
                            }, speed: 400, centeredSlides: true, onSlideChange: (s) => onUpdate(s, "month"), onSwiper: (s) => {
                                swiperMonth.current = s;
                            }, children: new Array(12).fill(0).map((_, i) => {
                                let monthName = (0, date_fns_1.format)((0, date_fns_1.setMonth)(current, i), "LLLL", {
                                    locale: locale,
                                });
                                return ((0, jsx_runtime_1.jsx)(react_2.SwiperSlide, { children: ({ isActive }) => ((0, jsx_runtime_1.jsx)("div", { className: [
                                            "flex items-center justify-center font-medium transition-all duration-300 cursor-pointer px-4",
                                            isActive
                                                ? "text-lg text-gray-900 bg-yellow-200"
                                                : " text-gray-500",
                                        ].join(" "), children: monthName })) }, monthName));
                            }) }) })] }), (0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col px-4 text-center", children: [(0, jsx_runtime_1.jsx)("h6", { className: "text-xs mb-3", children: "Tahun" }), (0, jsx_runtime_1.jsx)("div", { className: "flex-col flex max-h-24 overflow-auto", children: (0, jsx_runtime_1.jsx)(react_2.Swiper, { modules: [
                                swiper_1.Scrollbar,
                                swiper_1.A11y,
                                swiper_1.Autoplay,
                                swiper_1.EffectCreative,
                                swiper_1.Mousewheel,
                                swiper_1.FreeMode,
                            ], slidesPerView: 3, effect: "slide", direction: "vertical", simulateTouch: true, mousewheel: true, freeMode: {
                                enabled: true,
                                sticky: true,
                                momentumRatio: 5,
                                momentumBounceRatio: 5,
                                momentumVelocityRatio: 5,
                                minimumVelocity: 0.5,
                            }, speed: 400, centeredSlides: true, onSlideChange: (s) => onUpdate(s, "year"), onSwiper: (s) => {
                                swiperYear.current = s;
                            }, children: new Array(startYearCount).fill(0).map((_, i) => {
                                const n = i + 1;
                                const year = (0, date_fns_1.getYear)(initialDate.current) - startYearCount;
                                return ((0, jsx_runtime_1.jsx)(react_2.SwiperSlide, { children: ({ isActive }) => ((0, jsx_runtime_1.jsx)("div", { className: [
                                            "flex items-center justify-center font-medium transition-all duration-300 cursor-pointer px-4",
                                            isActive
                                                ? "text-lg text-gray-900 bg-yellow-200"
                                                : " text-gray-500",
                                        ].join(" "), children: year + n })) }, year + n));
                            }) }) })] })] }));
}
exports.default = YearlyCalendar;
